var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "21px",
    viewBox: "0 0 10 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93653125,10.0185937 L6.13621875,10.0185937 L6.13621875,20.0072813 L1.98196875,20.0072813 L1.98196875,10.0185937 L0.00815625,10.0185937 L0.00815625,6.492375 L1.98196875,6.492375 L1.98196875,4.208625 C1.98196875,2.5719375 2.75953125,0.01903125 6.1715625,0.01903125 L9.24646875,0.02990625 L9.24646875,3.45553125 L7.014375,3.45553125 C6.6500625,3.45553125 6.13621875,3.6376875 6.13621875,4.41525 L6.13621875,6.492375 L9.298125,6.492375 L8.93653125,10.0185937 Z",
    id: "Path"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.03a13da7a0a002f709c283ee2ec1ce77.svg";
export { ForwardRef as ReactComponent };